export const isIgnoredNode = node => {
  const type = typeof node;
  if (type === 'undefined' || type === 'boolean' || node === null) {
    return true;
  }
  return false;
};